import { ALL_TYPES } from "src/constants/taskTypes";
import { SortCell, TextCell } from "../cells";
import { Tooltip } from "@asayinc/component-library";
import { Column, RowData } from "../types";
import { Box } from "@mui/material";

interface RowDataWithType extends RowData {
  type: string;
}

export const typeColumn: Column<RowDataWithType> = {
  width: "1fr",
  label: (
    <SortCell sortKey="type" emphasis="medium">
      Type
    </SortCell>
  ),
  cell: (rowData) => (
    <Box>
      <Tooltip
        title={
          ALL_TYPES[rowData.type as keyof typeof ALL_TYPES]
            ? ALL_TYPES[rowData.type as keyof typeof ALL_TYPES].full
            : ""
        }
        placement="top"
        sx={{ display: "inline-grid" }}
      >
        <TextCell>
          {ALL_TYPES[rowData.type as keyof typeof ALL_TYPES]
            ? ALL_TYPES[rowData.type as keyof typeof ALL_TYPES].abbreviated
            : ""}
        </TextCell>
      </Tooltip>
    </Box>
  ),
};
